import { Component, Input } from '@angular/core';
import { NavigationItem } from '../navigation-tree/navigation-tree.constant';

@Component({
    selector: 'menu-list-item',
    templateUrl: './menu-list-item.component.html',
    styleUrls: ['./menu-list-item.component.scss'],
    standalone: false
})

export class MenuListItemComponent {
  @Input() item: NavigationItem;
  @Input() isChild: boolean;
}
